import {
  ADD_IMAGES_TO_VENUE,
  ADD_IMAGE_TO_EVENT,
  CREATE_VENUE,
  CREATE_VENUE_FAILED,
  CREATE_VENUE_SUCCESS,
  GET_FEATURES_BY_VENUE_ID,
  GET_FEATURES_BY_VENUE_ID_FAILED,
  GET_FEATURES_BY_VENUE_ID_SUCCESS,
  GET_VENUES,
  GET_VENUES_FAILED,
  GET_VENUES_SUCCESS,
  GET_VENUE_FEATURES,
  GET_VENUE_FEATURES_FAILED,
  GET_VENUE_FEATURES_SUCCESS,
  SET_BANNER_VENUE,
  SET_CURRENT_VENUE_USER,
  UPDATE_VENUE,
  UPDATE_VENUE_SUCCESS,
  UPDATE_VENUE_FAILED,
  GET_PICTURES_BY_VENUE,
  GET_PICTURES_BY_VENUE_SUCCESS,
  GET_PICTURES_BY_VENUE_FAILED,
  DELETE_VENUE_PICTURE,
  DELETE_VENUE_PICTURE_SUCCESS,
  DELETE_VENUE_PICTURE_FAILURE,
  SET_PRINCIPAL_BANNER_VENUE,
  GET_VENUE_BY_ID,
  GET_VENUE_BY_ID_SUCCESS,
  GET_VENUE_BY_ID_FAILED,
} from './constants';

const getVenueById = (id) => ({
  type: GET_VENUE_BY_ID,
  payload: { id },
});

const getVenueByIdSuccess = (venue) => ({
  type: GET_VENUE_BY_ID_SUCCESS,
  payload: { venue },
});

const getVenueByIdFailed = (error) => ({
  type: GET_VENUE_BY_ID_FAILED,
  payload: { error },
});

const getVenues = () => ({
  type: GET_VENUES,
});

const getVenuesSuccess = (venueList) => ({
  type: GET_VENUES_SUCCESS,
  payload: { venueList },
});

const getVenuesFailed = (error) => ({
  type: GET_VENUES_FAILED,
  payload: { error },
});

const getPicturesByVenue = (id) => ({
  type: GET_PICTURES_BY_VENUE,
  payload: { id },
});

const getPicturesByVenueSuccess = (pictures) => ({
  type: GET_PICTURES_BY_VENUE_SUCCESS,
  payload: { pictures },
});

const getPicturesByVenueFailed = (error) => ({
  type: GET_PICTURES_BY_VENUE_FAILED,
  payload: { error },
});

const addImagesToVenue = (pictures) => ({
  type: ADD_IMAGES_TO_VENUE,
  payload: { pictures },
});

const addImageToEvent = (pictures) => ({
  type: ADD_IMAGE_TO_EVENT,
  payload: { pictures },
});

const deleteVenuePicture = (key) => ({
  type: DELETE_VENUE_PICTURE,
  payload: key,
});

const deleteVenuePictureSuccess = (key) => ({
  type: DELETE_VENUE_PICTURE_SUCCESS,
  payload: key,
});

const deleteVenuePictureFailure = (error) => ({
  type: DELETE_VENUE_PICTURE_FAILURE,
  payload: error,
});

const createVenue = (venue, navigate) => ({
  type: CREATE_VENUE,
  payload: { venue, navigate },
});

const createVenueSuccess = (venue, success) => ({
  type: CREATE_VENUE_SUCCESS,
  payload: { venue, success },
});

const createVenueFailed = (error) => ({
  type: CREATE_VENUE_FAILED,
  payload: { error },
});

const getVenueFeatures = () => ({
  type: GET_VENUE_FEATURES,
});

const getVenueFeaturesSuccess = (features) => ({
  type: GET_VENUE_FEATURES_SUCCESS,
  payload: { features },
});

const getVenueFeaturesFailed = (error) => ({
  type: GET_VENUE_FEATURES_FAILED,
  payload: { error },
});

const setBannerVenue = (picture) => ({
  type: SET_BANNER_VENUE,
  payload: { picture },
});

const setPrincipalBannerVenue = (picture) => ({
  type: SET_PRINCIPAL_BANNER_VENUE,
  payload: { picture },
});

const setCurrentVenueUser = (venue) => ({
  type: SET_CURRENT_VENUE_USER,
  payload: { venue },
});

const getFeaturesByVenueId = (venueId) => ({
  type: GET_FEATURES_BY_VENUE_ID,
  payload: { venueId },
});

const getFeaturesByVenueIdSuccess = (data) => ({
  type: GET_FEATURES_BY_VENUE_ID_SUCCESS,
  payload: { data },
});

const getFeaturesByVenueIdFailed = (error) => ({
  type: GET_FEATURES_BY_VENUE_ID_FAILED,
  payload: { error },
});

const updateVenue = (venue) => ({
  type: UPDATE_VENUE,
  payload: { venue },
});

const updateVenueSuccess = (venue) => ({
  type: UPDATE_VENUE_SUCCESS,
  payload: { venue },
});

const updateVenueFailed = (error) => ({
  type: UPDATE_VENUE_FAILED,
  payload: { error },
});

export {
  getVenueById,
  getVenueByIdSuccess,
  getVenueByIdFailed,
  getVenues,
  getVenuesSuccess,
  getVenuesFailed,
  createVenue,
  createVenueSuccess,
  createVenueFailed,
  addImagesToVenue,
  addImageToEvent,
  getVenueFeatures,
  getVenueFeaturesFailed,
  getVenueFeaturesSuccess,
  setBannerVenue,
  setPrincipalBannerVenue,
  setCurrentVenueUser,
  getFeaturesByVenueId,
  getFeaturesByVenueIdSuccess,
  getFeaturesByVenueIdFailed,
  updateVenue,
  updateVenueSuccess,
  updateVenueFailed,
  getPicturesByVenue,
  getPicturesByVenueSuccess,
  getPicturesByVenueFailed,
  deleteVenuePicture,
  deleteVenuePictureSuccess,
  deleteVenuePictureFailure,
};
